module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am602-c73fdda71f2ffb978648eef5a5d51ec7.jpg";